import styled from 'styled-components';
import { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ThemeData } from '../../quant/quantData';
import Description_Box from '../../components/description/Description';

const QuantBox = () => {
  return (
    <Box gap={24} style={{ padding: '32px 16px' }}>
      <Text
        color="#222222"
        size={18}
        weight={700}
        style={{ textAlign: 'start' }}
      >
        퀀트 분석 기반 테마 추천(宙)
      </Text>
      <Description_Box
        desc1="복잡한 설정 없이, 이미 검증된 빅데이터 전략으로 경매 물건을 추천 받아보세요."
        desc2="설정할 필요 없이, 수십 년 축적된 데이터를 통해 가장 돈 되는 테마별 포트폴리오를 제시합니다."
      />
      <ItemBox>
        {ThemeData.map((item, index) => (
          <Item
            key={index}
            to={'/quant/theme?index=' + index + '&region=전국&category=전체'}
          >
            <TextBox>
              <ItemName>
                <span>{item.name}</span>
              </ItemName>
            </TextBox>
            <ItemImage
              src={'/assets/images/quant/' + item.image + '.png'}
              alt=""
              style={{ width: '44px', height: '44px' }}
            />
          </Item>
        ))}
      </ItemBox>
    </Box>
  );
};

export default QuantBox;

const ThemeStock = styled.div`
  width: 22;
  height: 17;
  gap: 10px;
  padding-right: 5px;
  padding-left: 5px;
  border-radius: 4px;
  background: linear-gradient(127.44deg, #008aff 0%, #d224ca 100%);
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  font-size: 12px;
  line-height: 145%;
  letter-spacing: -2%;
  color: #ffffff;
`;

const TitleBox = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const PageTitle = styled.div`
  font-family: Spoqa Han Sans Neo;
  font-size: 24px;
  font-weight: 700;
  line-height: 34.8px;
  color: #171e26;
`;

const Box = styled.div<{ gap?: number }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.gap}px;
`;

const Row = styled.div<{ gap?: number }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: ${(props) => props.gap}px;
`;

const Description = styled(Box)`
  width: 100%;
  gap: 8px;
  border-radius: 16px;
  padding: 24px;
  background: #f4f8ff;
  align-items: flex-start;
`;

const Text = styled.span<{ color: string; size: number; weight: number }>`
  font-family: Spoqa Han Sans Neo;
  font-weight: ${(props) => props.weight};
  font-size: ${(props) => props.size}px;
  line-height: 145%;
  letter-spacing: ${(props) => props.size * -0.02}px;
  text-align: center;
  color: ${(props) => props.color};
`;

const ItemBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  row-gap: 8px;
  column-gap: 8px;
`;

const Item = styled(Link)`
  text-decoration: none;
  width: calc(50% - 4px);
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  cursor: pointer;
  border-radius: 12px;
  padding: 14px 16px;
  background: #f7f8fc;
  border: 1px solid #e5e8ea;
  justify-content: space-between;
  &:hover {
    background-color: rgba(0, 0, 0, 0.04);
  }
  &:active {
    background-color: rgba(0, 0, 0, 0.09);
  }
`;

const ItemImage = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 16px;
`;
const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 7px;
  font-size: 13px;
  font-weight: 500;
  color: #616161;
  line-height: 145%;
  letter-spacing: calc(12px * -0.02);
  p {
    margin-block: 0;
  }
`;
const ItemName = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  font-weight: 700;
  color: #222222;
  word-break: keep-all;
`;
